<div class="dialog-banner">
  <mat-icon class="banner-icon">video_call</mat-icon>
  <div class="banner-text">
    <h2>{{ "COMPONENTS.REQUEST_CALL_DIALOG.HEADER" | translate }}</h2>
    <span>{{ "COMPONENTS.REQUEST_CALL_DIALOG.SUBTITLE" | translate }}</span>
  </div>
  <button mat-icon-button class="close-btn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<div class="filter-wrapper">
  <mat-form-field class="search-field" appearance="outline">
    <mat-label>{{ "COMPONENTS.REQUEST_CALL_DIALOG.FILTERS.SEARCH" | translate }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      placeholder="{{ 'COMPONENTS.REQUEST_CALL_DIALOG.FILTERS.SEARCH' | translate }}"
      (keyup)="applyFilter($event.target.value)"
      [(ngModel)]="currentFilter"
    />
    <button mat-icon-button matSuffix *ngIf="currentFilter" (click)="applyFilter(''); currentFilter='';"
            [attr.aria-label]="'COMMON.CLEAR' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="site-field" appearance="outline">
    <mat-label>{{ 'COMPONENTS.REQUEST_CALL_DIALOG.FILTERS.SITES' | translate }}</mat-label>
    <mat-select [(value)]="selectedSiteId" (selectionChange)="onSiteFilterChange($event.value)">
      <mat-option [value]="null">{{ 'COMPONENTS.REQUEST_CALL_DIALOG.FILTERS.SITES_ALL' | translate }}</mat-option>
      <mat-option *ngFor="let site of sites$ | async" [value]="site.id">
        {{site.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<section class="table-section" *ngIf="customerPermissions$ | async as customerPermissions">
  <!-- Empty state -->
  <div class="empty-state" *ngIf="dataSource.filteredData.length === 0">
    <mat-icon class="empty-icon">person_off</mat-icon>
    <span class="empty-title">{{ "COMPONENTS.REQUEST_CALL_DIALOG.EMPTY_TITLE" | translate }}</span>
    <span class="empty-subtitle">{{ "COMPONENTS.REQUEST_CALL_DIALOG.EMPTY_SUBTITLE" | translate }}</span>
  </div>

  <!-- Table -->
  <table
    mat-table
    [dataSource]="dataSource"
    *ngIf="(sitePermissions$ | async) && dataSource.filteredData.length > 0"
    matSort
    class="residents-table"
  >
    <!-- Avatar Column -->
    <ng-container matColumnDef="avatar">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resident">
        <app-avatar-thumbnail
          [user]="resident"
          size=40
          (click)="requestCall(resident)"
        ></app-avatar-thumbnail>
      </td>
    </ng-container>

    <!-- First Name Column -->
    <ng-container matColumnDef="first_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "COMPONENTS.REQUEST_CALL_DIALOG.TABLE_HEADERS.FIRST_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let resident">
        <a (click)="requestCall(resident)">{{ resident.first_name }}</a>
      </td>
    </ng-container>

    <!-- Last Name Column -->
    <ng-container matColumnDef="last_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "COMPONENTS.REQUEST_CALL_DIALOG.TABLE_HEADERS.LAST_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let resident">
        <a (click)="requestCall(resident)">{{ resident.last_name }}</a>
      </td>
    </ng-container>

    <!-- Username Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "COMPONENTS.REQUEST_CALL_DIALOG.TABLE_HEADERS.USERNAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let resident">
        <a (click)="requestCall(resident)">{{ resident.username }}</a>
      </td>
    </ng-container>

    <!-- Site Column -->
    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "COMPONENTS.REQUEST_CALL_DIALOG.TABLE_HEADERS.SITE" | translate }}
      </th>
      <td mat-cell *matCellDef="let resident">
        <span class="site-chip" (click)="requestCall(resident)">{{ resident.site?.name }}</span>
      </td>
    </ng-container>

    <!-- Screen Column -->
    <ng-container matColumnDef="screen">
      <th mat-header-cell *matHeaderCellDef>
        {{ "COMPONENTS.REQUEST_CALL_DIALOG.TABLE_HEADERS.SCREEN" | translate }}
      </th>
      <td mat-cell *matCellDef="let resident">
        <mat-icon
          *ngIf="resident.set_top_box"
          class="screen-status-icon"
          [class.screen-on]="resident.set_top_box.is_screen_on"
          [class.screen-off]="!resident.set_top_box.is_screen_on"
          [matTooltip]="resident.set_top_box.is_screen_on ? 'Screen is on' : 'Screen is off'"
        >
          {{ resident.set_top_box.is_screen_on ? 'tv' : 'tv_off' }}
        </mat-icon>
      </td>
    </ng-container>

    <!-- Call Column -->
    <ng-container matColumnDef="call">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resident">
        <button
          mat-icon-button
          class="call-btn"
          (click)="requestCall(resident)"
          [matTooltip]="'COMPONENTS.REQUEST_CALL_DIALOG.START_CALL' | translate"
        >
          <mat-icon>videocam</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="resident-row"></tr>
  </table>
</section>
